import { getContractTypesWhere } from '@Common/types/bo/b2b/contracts/contract_type_definitions';

import type { B2bContractType } from '@Common/types/bo/b2b/contracts';

type NonEmptyArray<T> = [T, ...T[]] & T[];

function assertNonEmpty<T>(items: T[], description: string): NonEmptyArray<T> {
  const [first, ...rest] = items;
  if (first === undefined) {
    throw new Error(`No ${description} contract type`);
  }
  return [first, ...rest];
}

/** "ER" (épargne retraite) contract types, except the ones run by an external insurer. */
export const erContractTypes: NonEmptyArray<B2bContractType> = assertNonEmpty(
  getContractTypesWhere(({ family, isExternal }) => family === 'er' && !isExternal),
  'ER',
);

/** "ES" (épargne salariale) contract types, across AXA and Malakoff Humanis. */
export const esContractTypes: NonEmptyArray<B2bContractType> = assertNonEmpty(
  getContractTypesWhere(({ family }) => family === 'es'),
  'ES',
);
